import { useEventContext } from './useEventContext';

export const useEventCategories = () => {
  const [state] = useEventContext();
  return state.initial ? [] : state.categories;
};
